module.exports = __webpack_public_path__ + "static/media/ryde_driver.28fed7c0.png";